import { FC } from "react";
import { useAnchorEl } from "shared/hooks/useAnchorEl";
import ComboDrawer from "./components/ComboDrawer";
import ComboTrigger from "./components/ComboTrigger";
import { ComboGroupedElement } from "./type";

type ComboboxProps = {
  title: string;
  selectedValues: string[];
  comboElements: ComboGroupedElement[];
  onSelectGroupedOptions: (values: string[]) => void;
  onClearSelectedOptions: () => void;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
};

const Combobox: FC<ComboboxProps> = ({
  title,
  selectedValues,
  comboElements,
  onSelectGroupedOptions,
  onClearSelectedOptions,
  searchQuery,
  setSearchQuery,
}) => {
  const { open, handleAnchorClose, handleAnchorOpen, anchorEl } = useAnchorEl();

  return (
    <div>
      <ComboTrigger
        title={title}
        count={selectedValues.length}
        onClick={handleAnchorOpen}
        open={open}
      />
      <ComboDrawer
        open={open}
        anchorEl={anchorEl}
        handleClose={handleAnchorClose}
        onSelectGroupedOptions={onSelectGroupedOptions}
        onClearSelectedOptions={onClearSelectedOptions}
        groupedElements={comboElements}
        selectedValues={selectedValues}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />
    </div>
  );
};

export default Combobox;
